import HSelectTree from "./h-select-tree/index"
import HPassword from "./h-password/index"
import HSwiper from "./h-swiper/index"
import HSwiperItem from "./h-swiper-item/index"
import HTree from "./h-tree/index"
import HPreviewImage from "./h-preview-image/index"

const components = [
    HSelectTree,
    HPassword,
    HSwiper,
    HSwiperItem,
    HTree,
    HPreviewImage
]
// 定义 install 方法，接收 Vue 作为参数。如果使用 use 注册插件，则所有的组件都将被注册
const install = function (Vue) {
    // 判断是否安装
    if (install.installed) return
    // 遍历注册全局组件
    components.map(component => Vue.component(component.name, component))
}

// 判断是否是直接引入文件
if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue)
}

// 解构导入
export {
    install,
    HSelectTree,
    HPassword,
    HSwiper,
    HSwiperItem,
    HTree,
    HPreviewImage
}
// 导出的对象必须具有 install，才能被 Vue.use() 方法安装
// 单独引入
export default {
    install,
    HSelectTree,
    HPassword,
    HSwiper,
    HSwiperItem,
    HTree,
    HPreviewImage
}